/** @format */

import React, { useEffect, useMemo, useState } from "react";
import { Expeditor, File, MapsData, Order, User } from "../../../services";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment/moment";
import Loading from "../../../components/shared/Loading/Loading";
import { onDebounce, requestErrorDisplay } from "../../../utils";
import OrdersCreateDesktopView from "../../../components/orders/views/OrdersCreateDesktopView";
import { t } from "i18next";
import { useLanguage } from "../../../context/LanguageContext";
import { WEIGHT_UNITS, getTransportTypeIcon } from "../../../mock";
import { getCitiesRefreshTargets } from "../utils/cityRefresh";
import { buildNewOrderPayload } from "../utils/newOrderPayload";
import { useWagonTypes } from "../../../hooks/useWagonTypes";
import { RAILWAY_ORDERS_PATH } from "../utils/railwayOrder";
import CustomButton from "../../../components/custom/custom-button/CustomButton";

const RAILWAY_SHIPMENT_TYPES = new Set(["railway_shipment", "railway_shipment_40"]);

const OrdersCreatePage = ({ isRailway = false }) => {
  const location = useLocation();
  const params = useParams();
  const { currentLanguage } = useLanguage();
  const wagonDirectory = useWagonTypes(isRailway, currentLanguage);
  const { user } = useSelector((state) => state);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [orderId, setOrderId] = useState(
    params?.id ? params?.id : searchParams.get("id") ? searchParams.get("id") : null,
  );
  const [recipientUpdate, setRecipientUpdate] = useState(0);
  const [isLoadingGet, setLoadingGet] = useState(true);

  // Default data
  const [countries, setCountries] = useState([]);
  const [categories, setCategories] = useState([]);
  const [types, setTypes] = useState([]);
  const [temperatures, setTemperatures] = useState([]);
  const [loadingTypes, setLoadingTypes] = useState([]);
  const [partners, setPartners] = useState([]);

  const [errors, setErrors] = useState({});
  // FORM
  // Selected data
  const [countryFrom, setCountryFrom] = useState();
  const [countryTo, setCountryTo] = useState();
  const [citiesFrom, setCitiesFrom] = useState([]);
  const [citiesTo, setCitiesTo] = useState([]);
  const [cityFrom, setCityFrom] = useState();
  const [cityTo, setCityTo] = useState();
  const [pickUpDate, setPickUpDate] = useState();
  const [shippingDateTo, setShippingDateTo] = useState(null);
  const [pickUpStartTime, setPickUpStartTime] = useState();
  const [pickUpEndTime, setPickUpEndTime] = useState();
  const [deliveryDate, setDeliveryDate] = useState();
  const [deliveryStartTime, setDeliveryStartTime] = useState();
  const [deliveryEndTime, setDeliveryEndTime] = useState();
  const [addressTo, setAddressTo] = useState();
  const [addressFrom, setAddressFrom] = useState();
  const [coordinatesFrom, setCoordinatesFrom] = useState("");
  const [coordinatesTo, setCoordinatesTo] = useState("");
  const [addressIdFrom, setAddressIdFrom] = useState("");
  const [addressIdTo, setAddressIdTo] = useState("");
  const [recipientName, setRecipientName] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [recipientPhone, setRecipientPhone] = useState();
  const [senderName, setSenderName] = useState("");
  const [senderPhone, setSenderPhone] = useState();
  const [category, setCategory] = useState();
  const [type, setType] = useState();
  const [wagonType, setWagonType] = useState(null);
  const [wagonsCount, setWagonsCount] = useState("");
  const [etsngCode, setEtsngCode] = useState("");
  const [gngCode, setGngCode] = useState("");
  const [weight, setWeight] = useState("");
  const [volume, setVolume] = useState("");
  const [pallet, setPallet] = useState("");
  const [tnvedCode, setTnvedCode] = useState("");
  const [weightUnit, setWeightUnit] = useState(() => ({ ...WEIGHT_UNITS(t).ton }));
  const [details, setDetails] = useState();
  const [copyCount, setCopyCount] = useState(1);
  const [price, setPrice] = useState(0);
  const [algoPrice, setAlgoPrice] = useState(0);
  const [predictedPrice, setPredictedPrice] = useState({});
  const [isAlgoPrice, setIsAlgoPrice] = useState(false);
  const [netPrice, setNetPrice] = useState();
  const [distance, setDistance] = useState();
  const [temperature, setTemperature] = useState();
  const [loadingType, setLoadingType] = useState();
  const [createLoading, setLoadingCreate] = useState(false);
  const [insurance, setInsurance] = useState(false);
  const [declaredPrice, setDeclaredPrice] = useState(0);
  const [insurancePrice, setInsurancePrice] = useState();
  const [minPickDate, setMinPickDate] = useState(new Date(new Date().setHours(0)));
  const [minDeliveryDate, setMinDeliveryDate] = useState();
  const [partner, setPartner] = useState([]);
  const [assignmentMethod, updateAssignmentMethod] = useState("Tender");
  const isTender = assignmentMethod !== "DirectAssignment";
  const [isComplexTender, updateIsComplexTender] = useState(location.pathname === "/orders/complex-tender/create");
  const setIsComplexTender = (value) => {
    updateIsComplexTender(value);
    if (isRailway && value) setWagonsCount("");
  };
  const [vehiclesCount, setVehiclesCount] = useState(1);
  const [incotermsEnabled, setIncotermsEnabled] = useState(false);
  const [incoterms, setIncoterms] = useState(null);
  useEffect(() => {
    if (!countryFrom?.id || !countryTo?.id || countryFrom.id === countryTo.id) {
      setIncoterms(null);
      setIncotermsEnabled(false);
    }
  }, [countryFrom?.id, countryTo?.id]);

  const [auctionStep, setAuctionStep] = useState("");
  const [extendAuction, setExtendAuction] = useState(false);
  const [isWithoutExecutor, setIsWithoutExecutor] = useState(isRailway);
  const [tenderDateEnd, setTenderDateEnd] = useState("");
  const [tenderEndTime, setTenderEndTime] = useState("");
  const [partnersForTender, setPartnersForTender] = useState([]);
  const [points, setPoints] = useState([]);
  const [routeDistance, setRouteDistance] = useState();
  const [routeDuration, setRouteDuration] = useState("");
  const [currency, setCurrency] = useState(null);
  const [acceptedCurrency, setAcceptedCurrency] = useState(null);

  const setAssignmentMethod = (method) => {
    updateAssignmentMethod(method);
    if (method === "DirectAssignment") setIsComplexTender(false);
  };

  const [citiesRefreshCountryId, setCitiesRefreshCountryId] = useState(null);

  const [isActualCities, setIsActualCities] = useState(true);
  const [isCalculatePrice, setIsCalculatePrice] = useState(true);

  // files
  const [files, setFiles] = useState([]);
  const [senderEmail, setSenderEmail] = useState("");
  const [fileInvoice, setInvoiceFile] = useState(null);

  //map
  const [isLoadingMap, setIsLoadingMap] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [routeData, setRouteData] = useState(null);
  const [routeStartCity, setRouteStartCity] = useState(null);

  const updatePrice = (newPrice) => {
    setPrice(newPrice);
  };

  const onResetPrice = () => {
    setAlgoPrice(0);
    setNetPrice(0);
    setDistance(0);
  };

  useEffect(() => {
    setIsActualCities(!(cityFrom?.isActual === false || cityTo?.isActual === false));
  }, [cityFrom, cityTo, isRailway]);

  useEffect(() => {
    if (RAILWAY_SHIPMENT_TYPES.has(type?.value)) {
      setIsWithoutExecutor(true);
    }
  }, [type?.value]);

  useEffect(() => {
    if (
      points.length === 0 &&
      cityFrom &&
      countryFrom &&
      cityTo &&
      countryTo &&
      category &&
      type &&
      weight &&
      volume &&
      routeDistance
    ) {
      orderCalculation();
    } else if (points.length !== 0) {
      setAlgoPrice(0);
    }
  }, [points]);

  useEffect(() => {
    if (!isRailway && cityFrom?.id && cityTo?.id) {
      Order.getCalculateOrderPrice(cityFrom.id, cityTo.id)
        .then((response) => {
          setIsCalculatePrice(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [cityFrom, cityTo]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (insurance && declaredPrice) {
        Order.calculateInsuranceSum(declaredPrice)
          .then((response) => {
            if (response?.data?.insuranceSum) {
              setInsurancePrice(response.data.insuranceSum);
            }
          })
          .catch((error) => {
            console.error('Error calculating insurance:', error);
            setInsurancePrice(null);
          });
      } else if (!declaredPrice || !insurance) {
        setInsurancePrice(null);
      }
    }, 800);

    return () => clearTimeout(timeoutId);
  }, [insurance, declaredPrice, price]);

  const getDefaultData = async () => {
    setLoadingGet(true);
    try {
      if (user && user.id) {
        await Order.getCountries(currentLanguage)
          .then((response) => {
            console.log("countries", response.data);
            setCountries(response.data);
          })
          .catch((error) => {
            console.log(error);
            toast.error(error);
          });
      } else {
        console.log("Пользователь не определен");
        setCountries([]);
      }

      await Order.getCategories(currentLanguage)
        .then((response) => {
          setCategories(response.data);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error);
        });

      await Order.getTypes()
        .then((response) => {
          console.log("types", response.data);
          const typesWithIcons = response.data.map(type => ({
            ...type,
            icon: getTransportTypeIcon(type.value)
          }));
          setTypes(typesWithIcons);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error);
        });

      await Order.getTemperaturesDisc()
        .then((response) => {
          console.log("Temperatures", response.data);
          setTemperatures(response.data);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error);
        });

      await Order.getLoadingTypesDisc(currentLanguage)
        .then((response) => {
          console.log("Temperatures", response.data);
          setLoadingTypes(response.data);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error);
        });
    } catch (e) {
      toast.error("Ошибка при загрузке данных");
    } finally {
      setLoadingGet(false);
    }
  };

  useEffect(() => {
    getDefaultData();
  }, [user?.id, currentLanguage]);

  useEffect(() => {
    Expeditor.getPartners()
      .then((response) => {
        if (response.status === 200) {
          const filteredPartners = response.data
            .filter((partner) => partner.state === "Confirmed" && partner.companyName)
            .map((partner) => ({
              ...partner,
              name: partner.companyName,
            }));

          setPartners(filteredPartners);
        } else {
          console.log("Список пуст");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (citiesRefreshCountryId) {
      const responseEvent = (cities) => {
        const targets = getCitiesRefreshTargets(citiesRefreshCountryId, countryFrom, countryTo);

        if (targets.from) setCitiesFrom(cities);
        if (targets.to) setCitiesTo(cities);
      };

      Order.getCities(currentLanguage, citiesRefreshCountryId)
        .then((res) => res.data)
        .then((data) => {
          const cities = data?.filter(city => city.name).sort((a, b) => a.name.localeCompare(b.name));
          responseEvent(cities);
        })
        .catch((error) => {
          requestErrorDisplay(error);
        })
        .finally(() => {
          setCitiesRefreshCountryId(null);
        });
    }
  }, [citiesRefreshCountryId]);

  useEffect(() => {
    const responseEvent = (cities) => {
      setCitiesFrom(cities);
    };

    if (citiesTo.length && countryFrom?.id && countryTo?.id === countryFrom.id) {
      responseEvent(citiesTo);
    } else if (countryFrom?.id) {
      Order.getCities(currentLanguage, countryFrom.id)
        .then((res) => res.data)
        .then((data) => {
          const cities = data?.filter(city => city.name).sort((a, b) => a.name.localeCompare(b.name));
          console.log("cities", cities);
          responseEvent(cities);
        })
        .catch((error) => {
          requestErrorDisplay(error);
        });
    }
  }, [countryFrom]);

  useEffect(() => {
    const responseEvent = (cities) => {
      setCitiesTo(cities);
    };
    if (citiesFrom.length && countryTo?.id && countryFrom?.id === countryTo.id) {
      responseEvent(citiesFrom);
    } else if (countryTo?.id) {
      Order.getCities(currentLanguage, countryTo.id)
        .then((res) => res.data)
        .then((data) => {
          const cities = data?.filter(city => city.name).sort((a, b) => a.name.localeCompare(b.name));
          console.log("cities", cities);
          responseEvent(cities);
        })
        .catch((error) => {
          requestErrorDisplay(error);
        });
    }
  }, [countryTo]);

  useEffect(() => {
    setIsLoadingMap(true);

    const isAddressRoute = addressIdFrom && addressIdTo && coordinatesFrom && coordinatesTo;
    const routeMethod = isAddressRoute ? "getRouteByAddressId" : "getRoute";
    const routeParams = isAddressRoute
      ? [addressIdFrom, addressIdTo]
      : [cityFrom?.id, cityTo?.id];

    if ((isAddressRoute && addressIdFrom && addressIdTo) || (!isAddressRoute && cityFrom?.id && cityTo?.id)) {
      MapsData[routeMethod](...routeParams)
        .then((response) => {
          try {
            if (response) setRouteDistance(response.data.distance);
            let parsedData = JSON.parse(response.data.jsonData);

            if (
              (isAddressRoute && response.data.fromCityId !== addressIdFrom) ||
              (!isAddressRoute && response.data.fromCityId !== cityFrom?.id)
            ) {
              parsedData = parsedData.reverse();
            }

            if (response) {
              setRouteStartCity(response.data.fromCityId);
              setRouteData(parsedData);
            } else {
              setRouteData(null);
              console.log(`[${routeMethod}]`, null);
            }
            setIsLoadingMap(false);
          } catch (error) {
            console.error("Ошибка при парсинге JSON:", error);
            setRouteData(null);
            setIsLoadingMap(false);
          }
        })
        .catch((error) => {
          console.error(error);
          setIsLoadingMap(true);
          toast.error("Произошла ошибка, попробуйте позже");
        });
    }
  }, [cityFrom, cityTo, addressIdFrom, addressIdTo, coordinatesFrom, coordinatesTo]);

  const addressList = [
    {
      userAddressId: addressIdFrom,
      countryId: countryFrom?.id,
      cityId: cityFrom?.id,
      address: addressFrom,
      shippingDate: pickUpDate ? moment(pickUpDate).format("YYYY-MM-DD") : null,
      shippingHourFrom: pickUpStartTime
        ? Number(moment(pickUpStartTime).format("HH"))
        : null,
      shippingHourTo: pickUpEndTime ? Number(moment(pickUpEndTime).format("HH")) : null,
      latLng: coordinatesFrom,
      type: 0,
      step: 1,
      isInterimPoint: false,
      recipientName: senderName,
      recipientPhoneNumber: senderPhone,
      recipientEmail: senderEmail,
    },
    ...points.map((point, index) => ({
      userAddressId: point.addressId,
      countryId: point.country.id,
      cityId: point.city.id,
      address: point.address ? point.address : "",
      shippingDate: point.shippingDate ? moment(point.shippingDate).format("YYYY-MM-DD") : null,
      shippingHourFrom: point.shippingHourFrom
        ? Number(moment(point.shippingHourFrom).format("HH"))
        : null,
      shippingHourTo: point.shippingHourTo
        ? Number(moment(point.shippingHourTo).format("HH"))
        : null,
      latLng: point.latLng,
      type: point.type,
      step: index + 2,
      isInterimPoint: true,
      recipientName: point.recipientName,
      recipientPhoneNumber: point.recipientPhoneNumber,
      recipientEmail: point.recipientEmail,
    })),
    {
      userAddressId: addressIdTo,
      countryId: countryTo?.id,
      cityId: cityTo?.id,
      address: addressTo,
      shippingDate: deliveryDate ? moment(deliveryDate).format("YYYY-MM-DD") : null,
      shippingHourFrom: deliveryStartTime
        ? Number(moment(deliveryStartTime).format("HH"))
        : null,
      shippingHourTo: deliveryEndTime
        ? Number(moment(deliveryEndTime).format("HH"))
        : null,
      latLng: coordinatesTo,
      type: 1,
      step: points.length + 2,
      isInterimPoint: false,
      recipientName: recipientName,
      recipientPhoneNumber: recipientPhone,
      recipientEmail: recipientEmail,
    },
  ];

  const formData = () => {
    return {
      userId: user.id,
      price: price,
      algoPrice: algoPrice,
      isAlgoPrice: isAlgoPrice,
      netPrice: price,
      countryIdFrom: countryFrom?.id,
      countryNameFrom: countryFrom?.name,
      cityNameFrom: cityFrom?.name,
      cityFromName: cityFrom?.name,
      cityIdFrom: cityFrom?.id,
      addressFrom: addressFrom,
      shippingDate: pickUpDate ? moment(pickUpDate).format("YYYY-MM-DD") : null,
      shippingHourFrom: pickUpStartTime ? Number(moment(pickUpStartTime).format("HH")) : null,
      shippingHourTo: pickUpEndTime ? Number(moment(pickUpEndTime).format("HH")) : null,
      recipientName: recipientName,
      recipientEmail: recipientEmail,
      recipientPhoneNumber: recipientPhone,
      countryIdTo: countryTo?.id,
      countryNameTo: countryTo?.name,
      cityIdTo: cityTo?.id,
      cityNameTo: cityTo?.name,
      addressTo: addressTo,
      latLng: coordinatesTo,
      unloadingDate: deliveryDate ? moment(deliveryDate).format("YYYY-MM-DD") : null,
      unloadingHourFrom: deliveryStartTime ? Number(moment(deliveryStartTime).format("HH")) : null,
      unloadingHourTo: deliveryEndTime ? Number(moment(deliveryEndTime).format("HH")) : null,
      details: details || t('ordersCreateDesktop.detailsSection.noDescription'),
      weight: weight ? String(weight).replace(",", ".") : null,
      volume: volume ? String(volume).replace(",", ".") : null,
      pallet: pallet ? String(pallet).replace(",", ".") : null,
      tnvedCode: tnvedCode ? tnvedCode : null,
      unitMeasurement: weightUnit.code,
      category: category?.value,
      vehicleType: type?.value,
      loadingTypeId: loadingType?.id,
      insuranceIncluded: insurance,
      cargoPrice: declaredPrice,
      insuranceSum: insurancePrice,
      copyCount: copyCount,
      isActualCities: isActualCities,
      expeditorId: partner.expeditorCompanyId,
      expeditors: partnersForTender.map(partner => partner.expeditorCompanyId),
      tenderDateEnd: tenderDateEnd,
      addressList: addressList,
      isExistInterimPoint: points.length > 0,
      distance: routeDistance ? routeDistance : 0,
      isCommission: false,
      commission: 0,
      currency: acceptedCurrency,
      temperature: temperature,
      isWithoutExecutor: isWithoutExecutor,
      isImportedFromExcel: false,
      acceptedCurrency: acceptedCurrency,
      bidReductionStep: auctionStep ? String(auctionStep).replace(",", ".") : null,
      isAuctionExtended: extendAuction
    };
  };

  const createDraftOrder = (withAlert = false) => {
    const orderType = orderId ? "updateDraft" : "createDraft";

    const data = buildNewOrderPayload(formData(), {
      isRailway, wagonType, wagonsCount, etsngCode, gngCode,
      assignmentMethod, isComplexTender, vehiclesCount, tenderDateEnd, tenderEndTime,
      partner, partnersForTender, incotermsEnabled, incoterms, shippingDateTo,
    });

    Order[orderType](data, orderId)
      .then((res) => res.data)
      .then((response) => {
        let oId = orderId;
        if (!oId) {
          oId = response.id;
          setOrderId(oId);
        }

        if (insurance && fileInvoice?.name) {
          uploadFile(oId, fileInvoice);
        }
        if (files.length) {
          files.forEach((f) => uploadFile(oId, f, 5));
        }
        if (withAlert) {
          toast.success(t("ordersCreate.toast.savedToDrafts"));
        }
      })
      .catch((error) => {
        console.log(error);
        requestErrorDisplay("[createDraftOrder] - Произошла ошибка");
      });
  };

  const saveDraft = (withOutDebounce = false) => {
    if (withOutDebounce) {
      createDraftOrder(true);
    } else {
      onDebounce(() => createDraftOrder(false), 400);
    }
  };

  const createOrder = () => {
    if (createLoading) return;
    const newWindow =
      insurance && user?.insuranceType !== "GeneralAgreement"
        ? window.open('', '_blank')
        : null;

    const data = buildNewOrderPayload(formData(), {
      isRailway, wagonType, wagonsCount, etsngCode, gngCode,
      assignmentMethod, isComplexTender, vehiclesCount, tenderDateEnd, tenderEndTime,
      partner, partnersForTender, incotermsEnabled, incoterms, shippingDateTo,
    });

    setLoadingCreate(true);

    Order.newCreate(data)
      .then((res) => res.data)
      .then(async (response) => {
        const uploadPromises = [];
        const ids = (response?.orders ?? (response?.id ? [response] : [])).map((item) => item.id);

        if (insurance && fileInvoice) {
          ids.forEach((id) => {
            uploadPromises.push(uploadFile(id, fileInvoice, 0));
          });
        }

        if (files.length) {
          ids.forEach((id) => {
            files.forEach((f) => {
              uploadPromises.push(uploadFile(id, f, 5));
            });
          });
        }

        toast.success(t("ordersCreate.toast.orderCreated"));

        const insuranceUrl = response?.insurance?.paymentUrl;
        if (user?.insuranceType !== "GeneralAgreement" && insurance && insuranceUrl && newWindow) {
          newWindow.location.href = insuranceUrl;
        } else if (newWindow) {
          newWindow.close();
        }

        await Promise.allSettled(uploadPromises);
        onOrderCreated(ids.length === 1 ? ids[0] : ids);
      })
      .catch((error) => {
        console.log(error);
        if (newWindow) newWindow.close();
        requestErrorDisplay(error, "Произошла ошибка, попробуйте позже");
      })
      .finally(() => {
        setLoadingCreate(false);
      })
  };

  const orderCalculation = () => {
    if (isRailway || points.length !== 0) {
      return;
    }

    const data = {
      countryFrom: `${countryFrom?.name}`,
      countryTo: `${countryTo?.name}`,
      weight: weightUnit.key === "kg" ? String(weight/1000).replace(",", ".") : String(weight).replace(",", "."),
      volume: String(volume).replace(",", "."),
      transportType: type.value,
      cargoCategory: category.name,
      loadingDate: pickUpDate ? moment(pickUpDate).format("YYYY-MM-DD") : null,
      distance: routeDistance ?  Math.round(routeDistance) : 0,
    };

    Order.getOrderPrice(data)
      .then((response) => {
        if (response.status == 200) {
          if (pickUpDate) {
            setAlgoPrice(response.data.predicted_price);
            setPredictedPrice({});
          } else {
            setPredictedPrice(response.data.predicted_price);
            setAlgoPrice(0);
          }
        } else {
          console.log(response);
          toast.error("[Calculation] - Произошла ошибка, попробуйте позже");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const uploadFile = (orderId, file, type = 0) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    formData.append("orderId", orderId);
    formData.append("FileName", file.name);
    formData.append("name", file.name);
    formData.append("Name", file.name);

    return File.addOrderDoc(formData)
      .then(() => {
        toast.info(t('ordersCreate.toast.fileUploaded'));
      })
      .catch((error) => {
        console.log(error);
        requestErrorDisplay(error, 'ordersCreate.errors.uploadFileError');
        return Promise.reject(error);
      });
  };

  const onOrderCreated = (orderId) => {
    navigate(isRailway ? RAILWAY_ORDERS_PATH : "/main");
  };

  const queryInsurance = (nextValue = !insurance) => {
    setInsurance(nextValue);
    if (!nextValue) {
      setDeclaredPrice(0);
      setInsurancePrice(null);
      setInvoiceFile({});
    }
  };

  if (isLoadingGet || wagonDirectory.isLoading) {
    return <Loading inBlock />;
  }
  if (wagonDirectory.failed) {
    return <div role="alert">
      <p>{t("railwayOrder.directoryError")}</p>
      <CustomButton text={t("authSession.retry")} onClick={wagonDirectory.retry} />
    </div>;
  }

  const getPropsData = () => ({
    isRailway,
    wagonTypes: wagonDirectory.options,
    wagonType,
    setWagonType,
    wagonsCount,
    setWagonsCount,
    etsngCode,
    setEtsngCode,
    gngCode,
    setGngCode,
    assignmentMethod,
    setAssignmentMethod,
    isComplexTender,
    setIsComplexTender,
    vehiclesCount,
    setVehiclesCount,
    incotermsEnabled,
    setIncotermsEnabled,
    incoterms,
    setIncoterms,
    auctionStep,
    setAuctionStep,
    extendAuction,
    setExtendAuction,
    setCountryFrom,
    setCityFrom,
    countries,
    countryFrom,
    citiesFrom,
    cityFrom,
    countryTo,
    setCountryTo,
    setCityTo,
    citiesTo,
    cityTo,
    pickUpDate,
    shippingDateTo,
    setShippingDateTo,
    pickUpStartTime,
    pickUpEndTime,
    minPickDate,
    setPickUpDate,
    setPickUpStartTime,
    setPickUpEndTime,
    deliveryDate,
    deliveryStartTime,
    deliveryEndTime,
    minDeliveryDate,
    setDeliveryDate,
    setDeliveryStartTime,
    setDeliveryEndTime,
    types,
    setType,
    setTemperature,
    type,
    addressTo,
    setAddressTo,
    setRecipientPhone,
    setRecipientName,
    recipientName,
    recipientPhone,
    recipientEmail,
    recipientUpdate,
    setRecipientEmail,
    addressFrom,
    setAddressFrom,
    setRecipientUpdate,
    volume,
    setVolume,
    weight,
    setWeight,
    weightUnit,
    setWeightUnit,
    pallet, 
    setPallet,
    tnvedCode,
    setTnvedCode,
    categories,
    category,
    setCategory,
    temperatures,
    temperature,
    loadingTypes,
    loadingType,
    setLoadingType,
    details,
    setDetails,
    insurance,
    queryInsurance,
    declaredPrice,
    setDeclaredPrice,
    fileInvoice,
    setInvoiceFile,
    files,
    setFiles,
    distance,
    price,
    netPrice,
    algoPrice,
    setAlgoPrice,
    predictedPrice,
    setPredictedPrice,
    insurancePrice,
    createLoading,
    copyCount,
    setCopyCount,
    createOrder,
    orderCalculation,
    onResetPrice,
    saveDraft,
    updatePrice,
    setIsСallСities: setCitiesRefreshCountryId,
    isCalculatePrice,
    isLoadingMap,
    routeData,
    routeStartCity,
    partners,
    setPartner,
    partner,
    isTender,
    tenderDateEnd,
    tenderEndTime,
    setTenderDateEnd,
    setTenderEndTime,
    partnersForTender,
    setPartnersForTender,
    setCoordinatesFrom,
    setCoordinatesTo,
    coordinatesFrom,
    coordinatesTo,
    addressIdFrom,
    addressIdTo,
    setAddressIdFrom,
    setAddressIdTo,
    points,
    setPoints,
    senderName,
    setSenderName,
    senderEmail,
    setSenderEmail,
    setSenderPhone,
    senderPhone,
    routeDistance,
    setRouteDistance,
    setRouteDuration,
    currency,
    setCurrency,
    acceptedCurrency,
    setAcceptedCurrency,
    isWithoutExecutor,
    setIsWithoutExecutor,
  });

  return (
    <>
      {isLoading && <Loading/>}
      <OrdersCreateDesktopView
        {...getPropsData()}
        onPriceChange={setPrice}
        errors={errors}
        setErrors={setErrors}
        setCategories={setCategories}
      />
    </>
  );
};

export default OrdersCreatePage;
